import theme from 'src/libs/styled-components/theme';
import { IconProps } from '..';

export default function IconClose({
  width = 24,
  height = 24,
  color = theme.palette.grayscale600
}: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M19.4401 6.69L17.3101 4.56L12.0001 9.885L6.69006 4.56L4.56006 6.69L9.88506 12L4.56006 17.31L6.69006 19.44L12.0001 14.115L17.3101 19.44L19.4401 17.31L14.1151 12L19.4401 6.69Z"
        fill={color}
      />
    </svg>
  );
}
